export default __webpack_public_path__ + "static/media/mother-with-baby.540af2f1.svg";